import Marquee from "react-fast-marquee";
import { MARQUEE_BRANDS, BRAND_GROUPS } from "../../lib/portfolioData";
import { SectionHeader, Reveal } from "./Reveal";

const Row = ({ direction = "left", speed = 40 }) => (
  <Marquee direction={direction} speed={speed} gradient={false} pauseOnHover className="py-4">
    {MARQUEE_BRANDS.map((b, i) => (
      <div key={`${b}-${i}`} className="flex items-center mx-8 md:mx-12">
        <span className="font-display text-3xl md:text-5xl tracking-tight text-white/25 hover:text-white transition-colors duration-300 whitespace-nowrap">
          {b}
        </span>
        <span className="ml-16 md:ml-24 text-accent text-xl">✦</span>
      </div>
    ))}
  </Marquee>
);

export const ClientMarquee = () => (
  <section id="brands" data-testid="brands-section" className="relative py-28 md:py-44 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeader chapter="04" overline="Client Portfolio" title="Trusted by global brands & advertisers." />
    </div>

    <div className="space-y-2 border-y border-white/10 py-6">
      <Row direction="left" speed={40} />
      <Row direction="right" speed={30} />
    </div>

    <div className="max-w-7xl mx-auto px-6 md:px-10 mt-20 grid md:grid-cols-3 gap-10">
      {BRAND_GROUPS.map((g, gi) => (
        <Reveal key={g.label} delay={gi * 0.1}>
          <div data-testid={`brand-group-${gi}`}>
            <p className="overline mb-5">{g.label}</p>
            <div className="flex flex-wrap gap-2.5">
              {g.brands.map((b) => (
                <span
                  key={b}
                  className="text-sm px-4 py-2 rounded-full border border-white/10 bg-[#0a1220]/60 text-[#94a3b8] hover:text-white hover:border-accent/40 transition-colors"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
